import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import HotelDatePicker from 'vue-hotel-datepicker';
import EventColumn from './EventColumn/EventColumn';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

Vue.use(VueFormGenerator);

export default {

  name: 'Events',

  inject: [
    'eventsData',
    'categoryData',
    'promises'
  ],

  components: {
    HotelDatePicker,
    'event-column': EventColumn
  },

  props: {
    category: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    }
  },

  watch: {
    filters: {
      handler: function (newValue) {
        this.filterEvents();
      },
      deep: true
    }
  },

  data () {
    return {
      activeTab: 0,
      showFilter: false,
      filteredEvents: [],
      isLoading: true,
      event: null,
      eventCategories: null,
      categoryItem: null,
      formOptions: {
        validateAfterChanged: true
      },
      filters: {
        categorySelected: null,
        titleSelected: null,
        typeSelected: null,
        fromDate: null,
        toDate: null
      }
    };
  },

  computed: {
    currentDate: function () {
      return new Date();
    },

    years: function () {
      this.activeTab = 1;
      if (this.currentDate.getMonth() > 8 && this.currentDate.getMonth() <= 9) {
        // switch to next years tab as default after September
        this.activeTab = 2;
      }
      if (this.currentDate.getMonth() > 9) {
        // show 2 years ahead in November + December
        return [this.currentDate.getFullYear(), this.currentDate.getFullYear() + 1, this.currentDate.getFullYear() + 2];
      }
      return [this.currentDate.getFullYear() - 1, this.currentDate.getFullYear(), this.currentDate.getFullYear() + 1];
    },

    format: function () {
      if (Translator.locale === 'de') {
        return 'DD.MM.YYYY';
      } else {
        return 'YYYY-MM-DD';
      }
    },

    i18n: function () {
      if (Translator.locale === 'de') {
        return {
          night: 'Tag',
          nights: 'Tage',
          'day-names': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          'check-in': 'Von',
          'check-out': 'Bis',
          'month-names': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
        };
      } else {
        return {
          night: 'Day',
          nights: 'Days',
          'day-names': ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
          'check-in': 'From',
          'check-out': 'To',
          'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        };
      }
    },

    categoryNames: function () {
      let categoryIndex = null;
      let categoryArray = [];
      for (categoryIndex in this.categoryData.categories) {
        categoryArray.push({
          id: this.categoryData.categories[categoryIndex].slug,
          name: this.categoryData.categories[categoryIndex].title
        });
      }

      return categoryArray;
    },

    typeNames: function () {
      return [
        {
          id: 'bookable',
          name: this.$options.filters.trans('bookable')
        },
        {
          id: 'on_request',
          name: this.$options.filters.trans('on_request')
        },
        {
          id: 'preview',
          name: this.$options.filters.trans('preview')
        },
        {
          id: 'review',
          name: this.$options.filters.trans('review')
        }
        // {
        //   id: 'fully_booked',
        //   name: this.$options.filters.trans('fully_booked')
        // },
      ];
    },

    categoryName: function () {
      let name = null;
      let categoryIndex = null;
      for (categoryIndex in this.categoryNames) {
        if (this.filters.categorySelected === this.categoryNames[categoryIndex].id) {
          name = this.categoryNames[categoryIndex].name;
        }
      }

      return name;
    },

    generateFilter: function () {
      let titleFilterText = 'Titel / Item Nr';
      let categoryFilterText = '- alle Kategorien -';
      let typeFilterText = '- alle Verfügbarkeiten -';
      if (Translator.locale === 'en') {
        titleFilterText = 'Title / Item Nr';
        categoryFilterText = '- all categories -';
        typeFilterText = '- all availabilities -';
      }
      return {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            model: 'titleSelected',
            readonly: false,
            featured: true,
            required: false,
            disabled: false,
            placeholder: titleFilterText,
            validator: VueFormGenerator.validators.string
          },
          {
            type: 'select',
            model: 'typeSelected',
            values: this.typeNames,
            selectOptions: {
              noneSelectedText: typeFilterText
            },
            styleClasses: 'select-outer-coe coe-icon-arrow-down',
            required: false
          },
          {
            type: 'select',
            model: 'categorySelected',
            values: this.categoryNames,
            selectOptions: {
              noneSelectedText: categoryFilterText
            },
            styleClasses: 'select-outer-coe coe-icon-arrow-down',
            required: false
          }
        ]
      };
    }
  },

  methods: {
    checkInChanged: function (newDate) {
      Vue.set(this.filters, 'fromDate', newDate);
      this.filterEvents();
    },

    checkOutChanged: function (newDate) {
      Vue.set(this.filters, 'toDate', newDate);
      this.filterEvents();
    },

    filterEvents: function () {
      let filteredEvents = this.eventsData.events;

      if (this.filters.categorySelected) {
        this.$router.push({ name: 'Events', query: { category: this.filters.categorySelected } });
        let categoryFiltered = [];
        for (this.event in this.eventsData.events) {
          this.eventCategories = this.eventsData.events[this.event].categories;
          for (this.categoryItem in this.eventCategories) {
            if (this.filters.categorySelected === this.eventCategories[this.categoryItem].slug) {
              categoryFiltered.push(this.eventsData.events[this.event]);
            }
          }
        }
        filteredEvents = categoryFiltered;
      }
      if (this.filters.typeSelected) {
        let typeFiltered = [];
        for (this.event in filteredEvents) {
          if (this.filters.typeSelected === filteredEvents[this.event].type || (this.filters.typeSelected === 'review' && new Date(filteredEvents[this.event].date) <= this.currentDate)) {
            if (this.filters.typeSelected !== 'review' && filteredEvents[this.event].type !== 'review' && new Date(filteredEvents[this.event].date) <= this.currentDate) {
              continue;
            }
            typeFiltered.push(filteredEvents[this.event]);
          }
        }
        filteredEvents = typeFiltered;
      }
      if (this.filters.titleSelected) {
        let titleFiltered = [];
        for (this.event in filteredEvents) {
          if (filteredEvents[this.event].title.toLowerCase().indexOf(this.filters.titleSelected.toLowerCase()) !== -1) {
            titleFiltered.push(filteredEvents[this.event]);
          } else if (filteredEvents[this.event].itemNr && filteredEvents[this.event].itemNr.indexOf(this.filters.titleSelected) !== -1) {
            titleFiltered.push(filteredEvents[this.event]);
          }
        }
        filteredEvents = titleFiltered;
      }
      if (this.filters.fromDate) {
        let fromDateFiltered = [];
        for (let eventUuid in filteredEvents) {
          if (filteredEvents[eventUuid].hasOwnProperty('date')) {
            if (this.filters.toDate) {
              if (filteredEvents[eventUuid].hasOwnProperty('endDate')) {
                if (
                  new Date(filteredEvents[eventUuid].date).getTime() < this.filters.toDate.getTime() &&
                  new Date(filteredEvents[eventUuid].date).getTime() > this.filters.fromDate.getTime()
                ) {
                  fromDateFiltered.push(filteredEvents[eventUuid]);
                }
              }
            } else {
              if (new Date(filteredEvents[eventUuid].date).getTime() > this.filters.fromDate.getTime()) {
                fromDateFiltered.push(filteredEvents[eventUuid]);
              }
            }
          }
        }
        filteredEvents = fromDateFiltered;
      }

      this.filteredEvents = filteredEvents;
    }
  },

  beforeMount: function () {
    if (this.category) {
      this.filters.categorySelected = this.category;
    }
  },

  mounted: function () {
    let proxy = this;
    this.promises.events.promise.then(function () {
      proxy.filterEvents();
      proxy.isLoading = false;
    });
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/events/Events.js